// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-fk-relations directly.
import type { CatalogItemType } from "building-types/doc/catalogTypes";
import type { DocEntityType } from "building-types/doc/docEntityTypes";

/**
 * docEntityTypesContainingForeignKeys is a mapping of doc entity types to a boolean indicating
 * whether fk() property definitions exist directly on the entity or in any nested object fields
 * the entity contains.
 */

export const docEntityTypesContainingForeignKeys: {
  [key in DocEntityType]: boolean;
} = {
  ANNOTATION: true,
  ASSET: false,
  AUTO_DIMENSION: false,
  BLOCK: true,
  BUILDER_REF: false,
  CASEWORK: true,
  CATALOG_ITEM: false,
  CEILING: true,
  COLUMN: true,
  COMPONENT: false,
  COMPONENT_INSTANCE: true,
  COMPOSITE_LEVEL: true,
  CONTENT_REPLICATOR: true,
  CONTENT_TEMPLATE: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  DATA_SEQUENCE: false,
  DATA_TABLE: true,
  DATUM: true,
  DOC_REF: false,
  DORMER: true,
  DRAWING_REF: true,
  EDGE: false,
  EDGE_BEHAVIOR: true,
  EDGE_MODIFIER: true,
  EDIT_MODE: false,
  EFFECT: true,
  ELECTRICAL_DEVICE: true,
  ELECTRICAL_LAYOUT: true,
  ELECTRICAL_RULE: true,
  ELEVATION: true,
  ELEVATION_VIEW: true,
  ENTITY_SETTINGS: true,
  FACADE: true,
  FACADE_SPAN_STRATUM: true,
  FACADE_SWEEP_STRATUM: true,
  FLOOR: true,
  FLOOR_BAY: false,
  FLOOR_FINISH: true,
  FLOOR_PERIMETER_OPENING: false,
  FLOOR_SPLIT_LINE: false,
  FLOOR_SYSTEM: true,
  FOUNDATION: true,
  FOUNDATION_ASSEMBLY: true,
  FOUNDATION_COMPONENT: false,
  FOUNDATION_SYSTEM: true,
  FRAME_FLOOR_ASSEMBLY: true,
  FRAMING_COMPONENT: false,
  GENERATED_ENTITY: false,
  GLOBAL_PARAMETER: true,
  GROUP: true,
  HEADER_ASSEMBLY: true,
  INDETERMINATE_ENTITY_TYPE: false,
  INSTANCE_OPTION_SET: true,
  LABEL: false,
  LEVEL: true,
  LOCAL_PARAMETER: true,
  MASONRY_COMPONENT: false,
  MEASUREMENT: true,
  MODIFIER: true,
  OPENING: true,
  OPTION: true,
  OPTION_EFFECT: true,
  OPTION_LOCK: true,
  OPTION_RULE: true,
  OPTION_SET: true,
  OPTION_SET_OVERRIDES: true,
  OPTION_SET_REF: true,
  OPTION_TEMPLATE: false,
  PALETTE: false,
  PLAN_SET_TEMPLATE: false,
  PLAN_SET_TEMPLATE_CONFIG: true,
  PLAN_VIEW: true,
  PRESET: true,
  PROFILE: false,
  PROP: true,
  PROP_INSTANCE: true,
  RAILING: true,
  RAILING_POST: true,
  REFERENCE_GEOM: false,
  REPORTABLE_UNIT_DESIGNATION: true,
  ROOF: true,
  ROOF_OPENING: true,
  ROOF_SIDE: false,
  ROOF_SYSTEM: true,
  ROOF_VOLUME: true,
  ROOM: true,
  ROOM_LAYOUT: true,
  ROOM_LAYOUT_INSTANCE: true,
  RULE_BASED_SELECTOR: true,
  RULE_BASED_SELECTOR_INSTANCE: true,
  SECTION_VIEW: true,
  SELECTOR: true,
  SETTINGS: true,
  SETTINGS_SET: true,
  SHAPE: true,
  SHEATHING_COMPONENT: false,
  SHEET: true,
  SITE: true,
  SITE_SHAPE: true,
  SKYLIGHT: true,
  SLAB_COMPONENT: false,
  SLAB_FLOOR_ASSEMBLY: true,
  STAIR_BLOCK: true,
  STAIR_SYSTEM: true,
  SYSTEM_PARAMETER: true,
  UNDERLAY: true,
  VERTEX: false,
  VIEW_3D: true,
  VIEW_OVERRIDE: true,
  VIEW_SELECTOR: true,
  VIEW_TEMPLATE: true,
  VIEW_TEMPLATE_OVERRIDE: true,
  VIEWPORT: true,
  WALL_PLANE_ASSEMBLY: true,
  WALL_PLANE_FILTER: false,
  WALL_PLANE_RULE: true,
  WALL_PLANE_TRIM: true,
};

/**
 * docEntityTypeToReferenceTypes maps a source DocEntityType to the list of DocEntityTypes
 * that it can reference according to the schema (fk() / fkTable()) and dynamic foreign key strings.
 * This is schema-level capability, not instance usage.
 */
export const docEntityTypeToReferenceTypes = {
  ANNOTATION: [
    "ASSET",
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "ELEVATION_VIEW",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "ROOM_LAYOUT",
    "SECTION_VIEW",
    "SYSTEM_PARAMETER",
  ],
  ASSET: [],
  AUTO_DIMENSION: [],
  BLOCK: ["GLOBAL_PARAMETER", "LEVEL", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  BUILDER_REF: [],
  CASEWORK: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOM", "ROOM_LAYOUT", "SYSTEM_PARAMETER"],
  CATALOG_ITEM: [],
  CEILING: [
    "COMPONENT_INSTANCE",
    "DATUM",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "SYSTEM_PARAMETER",
  ],
  COLUMN: [
    "DATUM",
    "FOUNDATION_ASSEMBLY",
    "GLOBAL_PARAMETER",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "STAIR_BLOCK",
    "SYSTEM_PARAMETER",
  ],
  COMPONENT: [],
  COMPONENT_INSTANCE: [
    "COMPONENT",
    "COMPONENT_INSTANCE",
    "DATUM",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  COMPOSITE_LEVEL: ["COMPONENT_INSTANCE", "LEVEL"],
  CONTENT_REPLICATOR: [
    "CONTENT_TEMPLATE",
    "DATA_SEQUENCE",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  CONTENT_TEMPLATE: ["LABEL"],
  CONTENT_TEMPLATE_INSTANCE: [
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_SEQUENCE",
    "ELEVATION_VIEW",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PLAN_SET_TEMPLATE",
    "PRESET",
    "ROOM",
    "ROOM_LAYOUT",
    "SECTION_VIEW",
    "SYSTEM_PARAMETER",
    "VIEW_3D",
    "VIEW_TEMPLATE",
  ],
  DATA_SEQUENCE: [],
  DATA_TABLE: [
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_SEQUENCE",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PRESET",
    "SYSTEM_PARAMETER",
  ],
  DATUM: ["LEVEL"],
  DOC_REF: [],
  DORMER: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOF", "SYSTEM_PARAMETER"],
  DRAWING_REF: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SHEET", "SYSTEM_PARAMETER"],
  EDGE: [],
  EDGE_BEHAVIOR: [
    "COMPONENT_INSTANCE",
    "DATUM",
    "FACADE",
    "FOUNDATION",
    "FOUNDATION_ASSEMBLY",
    "FOUNDATION_COMPONENT",
    "GLOBAL_PARAMETER",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "STAIR_BLOCK",
    "SYSTEM_PARAMETER",
  ],
  EDGE_MODIFIER: ["MODIFIER", "RAILING", "ROOF", "ROOM"],
  EDIT_MODE: [],
  EFFECT: ["VIEW_TEMPLATE_OVERRIDE"],
  ELECTRICAL_DEVICE: [
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PROP",
    "REFERENCE_GEOM",
    "ROOM",
    "SYSTEM_PARAMETER",
  ],
  ELECTRICAL_LAYOUT: [
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PROP",
    "REFERENCE_GEOM",
    "ROOM",
    "SYSTEM_PARAMETER",
  ],
  ELECTRICAL_RULE: ["PROP", "REFERENCE_GEOM", "ROOM", "SETTINGS", "SETTINGS_SET"],
  ELEVATION: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  ELEVATION_VIEW: ["LABEL"],
  ENTITY_SETTINGS: [
    "DORMER",
    "FLOOR",
    "FOUNDATION",
    "OPENING",
    "ROOF",
    "ROOF_OPENING",
    "ROOM",
    "SETTINGS",
    "SETTINGS_SET",
  ],
  FACADE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  FACADE_SPAN_STRATUM: [
    "COMPONENT_INSTANCE",
    "DATUM",
    "FACADE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  FACADE_SWEEP_STRATUM: [
    "COMPONENT_INSTANCE",
    "DATUM",
    "FACADE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  FLOOR: [
    "FLOOR_SYSTEM",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "SYSTEM_PARAMETER",
  ],
  FLOOR_BAY: [],
  FLOOR_FINISH: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOM", "SYSTEM_PARAMETER"],
  FLOOR_PERIMETER_OPENING: [],
  FLOOR_SPLIT_LINE: [],
  FLOOR_SYSTEM: [
    "DATUM",
    "FRAME_FLOOR_ASSEMBLY",
    "FRAMING_COMPONENT",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SLAB_FLOOR_ASSEMBLY",
    "SYSTEM_PARAMETER",
  ],
  FOUNDATION: [
    "DATUM",
    "FOUNDATION_ASSEMBLY",
    "FOUNDATION_SYSTEM",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  FOUNDATION_ASSEMBLY: ["DATUM", "FOUNDATION_COMPONENT"],
  FOUNDATION_COMPONENT: [],
  FOUNDATION_SYSTEM: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  FRAME_FLOOR_ASSEMBLY: ["FRAMING_COMPONENT", "SHEATHING_COMPONENT"],
  FRAMING_COMPONENT: [],
  GENERATED_ENTITY: [],
  GLOBAL_PARAMETER: [
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE",
    "DATA_SEQUENCE",
    "ELEVATION_VIEW",
    "LABEL",
    "LEVEL",
    "OPTION",
    "OPTION_SET",
    "PRESET",
    "SECTION_VIEW",
    "VIEW_TEMPLATE",
  ],
  GROUP: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  HEADER_ASSEMBLY: ["FRAMING_COMPONENT"],
  INDETERMINATE_ENTITY_TYPE: [],
  INSTANCE_OPTION_SET: ["COMPONENT_INSTANCE", "OPTION_SET"],
  LABEL: [],
  LEVEL: [
    "COMPONENT_INSTANCE",
    "DATUM",
    "GLOBAL_PARAMETER",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  LOCAL_PARAMETER: [
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE",
    "DATA_SEQUENCE",
    "ELEVATION_VIEW",
    "LABEL",
    "LEVEL",
    "OPTION",
    "OPTION_SET",
    "PLAN_SET_TEMPLATE",
    "PRESET",
    "SECTION_VIEW",
    "VIEW_TEMPLATE",
  ],
  MASONRY_COMPONENT: [],
  MEASUREMENT: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOM", "SYSTEM_PARAMETER"],
  MODIFIER: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  OPENING: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOM", "ROOM_LAYOUT", "SYSTEM_PARAMETER"],
  OPTION: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  OPTION_EFFECT: ["OPTION", "OPTION_RULE", "OPTION_SET"],
  OPTION_LOCK: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  OPTION_RULE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  OPTION_SET: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  OPTION_SET_OVERRIDES: [
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "OPTION_TEMPLATE",
    "SYSTEM_PARAMETER",
  ],
  OPTION_SET_REF: ["BUILDER_REF", "OPTION_SET"],
  OPTION_TEMPLATE: [],
  PALETTE: [],
  PLAN_SET_TEMPLATE: [],
  PLAN_SET_TEMPLATE_CONFIG: [
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE",
    "DATA_SEQUENCE",
    "ELEVATION_VIEW",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "PLAN_SET_TEMPLATE",
    "PRESET",
    "SECTION_VIEW",
    "SYSTEM_PARAMETER",
    "VIEW_3D",
    "VIEW_TEMPLATE",
  ],
  PLAN_VIEW: ["COMPONENT_INSTANCE", "COMPOSITE_LEVEL", "LABEL", "LEVEL"],
  PRESET: ["OPTION", "OPTION_SET"],
  PROFILE: [],
  PROP: ["ASSET", "LABEL", "SETTINGS_SET"],
  PROP_INSTANCE: [
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PROP",
    "ROOM",
    "ROOM_LAYOUT",
    "SYSTEM_PARAMETER",
  ],
  RAILING: ["GLOBAL_PARAMETER", "LABEL", "LEVEL", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  RAILING_POST: ["RAILING"],
  REFERENCE_GEOM: [],
  REPORTABLE_UNIT_DESIGNATION: ["LABEL"],
  ROOF: [
    "BLOCK",
    "COMPONENT_INSTANCE",
    "FACADE",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PROP",
    "ROOF_SYSTEM",
    "SYSTEM_PARAMETER",
  ],
  ROOF_OPENING: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOF", "SYSTEM_PARAMETER"],
  ROOF_SIDE: [],
  ROOF_SYSTEM: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  ROOF_VOLUME: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  ROOM: [
    "BLOCK",
    "CONTENT_TEMPLATE",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
  ],
  ROOM_LAYOUT: ["ROOM"],
  ROOM_LAYOUT_INSTANCE: [
    "ANNOTATION",
    "CASEWORK",
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPENING",
    "OPTION",
    "OPTION_SET",
    "PROP_INSTANCE",
    "ROOM",
    "ROOM_LAYOUT",
    "SYSTEM_PARAMETER",
  ],
  RULE_BASED_SELECTOR: ["GLOBAL_PARAMETER", "LABEL", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  RULE_BASED_SELECTOR_INSTANCE: ["RULE_BASED_SELECTOR", "VIEW_TEMPLATE_OVERRIDE"],
  SECTION_VIEW: ["LABEL"],
  SELECTOR: ["COMPOSITE_LEVEL", "LEVEL", "ROOM", "VIEW_OVERRIDE"],
  SETTINGS: [
    "ASSET",
    "DATUM",
    "FRAME_FLOOR_ASSEMBLY",
    "GLOBAL_PARAMETER",
    "HEADER_ASSEMBLY",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PROP",
    "REFERENCE_GEOM",
    "ROOM",
    "SETTINGS",
    "SETTINGS_SET",
    "SLAB_FLOOR_ASSEMBLY",
    "STAIR_BLOCK",
    "SYSTEM_PARAMETER",
  ],
  SETTINGS_SET: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  SHAPE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOM", "SYSTEM_PARAMETER"],
  SHEATHING_COMPONENT: [],
  SHEET: ["GLOBAL_PARAMETER", "LABEL", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  SITE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  SITE_SHAPE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SITE", "SYSTEM_PARAMETER"],
  SKYLIGHT: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "ROOF", "SYSTEM_PARAMETER"],
  SLAB_COMPONENT: [],
  SLAB_FLOOR_ASSEMBLY: ["SHEATHING_COMPONENT", "SLAB_COMPONENT"],
  STAIR_BLOCK: [
    "DATUM",
    "GLOBAL_PARAMETER",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOM",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "SYSTEM_PARAMETER",
  ],
  STAIR_SYSTEM: ["GLOBAL_PARAMETER", "LABEL", "LEVEL", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  SYSTEM_PARAMETER: [],
  UNDERLAY: ["ASSET", "LEVEL"],
  VERTEX: [],
  VIEW_3D: ["LABEL", "LEVEL"],
  VIEW_OVERRIDE: ["GLOBAL_PARAMETER", "LOCAL_PARAMETER", "OPTION", "OPTION_SET", "SYSTEM_PARAMETER"],
  VIEW_SELECTOR: ["ELEVATION_VIEW", "PLAN_VIEW", "SECTION_VIEW", "VIEW_3D", "VIEW_OVERRIDE"],
  VIEW_TEMPLATE: ["CONTENT_TEMPLATE", "VIEW_TEMPLATE_OVERRIDE"],
  VIEW_TEMPLATE_OVERRIDE: ["LABEL"],
  VIEWPORT: [
    "COMPONENT_INSTANCE",
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LABEL",
    "LEVEL",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "PRESET",
    "SYSTEM_PARAMETER",
    "VIEW_TEMPLATE",
    "VIEW_TEMPLATE_OVERRIDE",
  ],
  WALL_PLANE_ASSEMBLY: ["FRAMING_COMPONENT", "LABEL", "MASONRY_COMPONENT", "SHEATHING_COMPONENT"],
  WALL_PLANE_FILTER: [],
  WALL_PLANE_RULE: [
    "DATUM",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "ROOF",
    "SYSTEM_PARAMETER",
    "WALL_PLANE_ASSEMBLY",
    "WALL_PLANE_FILTER",
  ],
  WALL_PLANE_TRIM: [
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "OPTION",
    "OPTION_SET",
    "SYSTEM_PARAMETER",
    "WALL_PLANE_RULE",
  ],
} as const;

/**
 * docEntityTypeToReverseReferenceTypes maps a target DocEntityType to the list of DocEntityTypes
 * that can reference it according to the schema (fk() / fkTable()) and dynamic foreign key strings.
 * This is schema-level capability, not instance usage.
 */
export const docEntityTypeToReverseReferenceTypes = {
  ANNOTATION: ["ROOM_LAYOUT_INSTANCE"],
  ASSET: ["ANNOTATION", "PROP", "SETTINGS", "UNDERLAY"],
  AUTO_DIMENSION: [],
  BLOCK: ["ROOF", "ROOM"],
  BUILDER_REF: ["OPTION_SET_REF"],
  CASEWORK: ["ROOM_LAYOUT_INSTANCE"],
  CATALOG_ITEM: [],
  CEILING: [],
  COLUMN: [],
  COMPONENT: [
    "BLOCK",
    "COMPONENT_INSTANCE",
    "FLOOR_SYSTEM",
    "FOUNDATION_SYSTEM",
    "LEVEL",
    "RAILING",
    "ROOF",
    "ROOF_SYSTEM",
    "ROOM",
    "STAIR_SYSTEM",
  ],
  COMPONENT_INSTANCE: [
    "CEILING",
    "COMPONENT_INSTANCE",
    "COMPOSITE_LEVEL",
    "EDGE_BEHAVIOR",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "INSTANCE_OPTION_SET",
    "LEVEL",
    "PLAN_VIEW",
    "ROOF",
    "VIEWPORT",
  ],
  COMPOSITE_LEVEL: [
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PLAN_VIEW",
    "SELECTOR",
    "VIEWPORT",
  ],
  CONTENT_REPLICATOR: [],
  CONTENT_TEMPLATE: [
    "ANNOTATION",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "ROOM",
    "VIEW_TEMPLATE",
    "VIEWPORT",
  ],
  CONTENT_TEMPLATE_INSTANCE: [
    "ANNOTATION",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "ROOM_LAYOUT_INSTANCE",
    "VIEWPORT",
  ],
  DATA_SEQUENCE: [
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
  ],
  DATA_TABLE: [],
  DATUM: [
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "EDGE_BEHAVIOR",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_ASSEMBLY",
    "LEVEL",
    "SETTINGS",
    "STAIR_BLOCK",
    "WALL_PLANE_RULE",
  ],
  DOC_REF: [],
  DORMER: ["ENTITY_SETTINGS"],
  DRAWING_REF: [],
  EDGE: [],
  EDGE_BEHAVIOR: [],
  EDGE_MODIFIER: [],
  EDIT_MODE: [],
  EFFECT: [],
  ELECTRICAL_DEVICE: [],
  ELECTRICAL_LAYOUT: [],
  ELECTRICAL_RULE: [],
  ELEVATION: [],
  ELEVATION_VIEW: [
    "ANNOTATION",
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "VIEW_SELECTOR",
  ],
  ENTITY_SETTINGS: [],
  FACADE: ["EDGE_BEHAVIOR", "FACADE_SPAN_STRATUM", "FACADE_SWEEP_STRATUM", "ROOF"],
  FACADE_SPAN_STRATUM: [],
  FACADE_SWEEP_STRATUM: [],
  FLOOR: ["ENTITY_SETTINGS"],
  FLOOR_BAY: [],
  FLOOR_FINISH: [],
  FLOOR_PERIMETER_OPENING: [],
  FLOOR_SPLIT_LINE: [],
  FLOOR_SYSTEM: ["FLOOR"],
  FOUNDATION: ["EDGE_BEHAVIOR", "ENTITY_SETTINGS"],
  FOUNDATION_ASSEMBLY: ["COLUMN", "EDGE_BEHAVIOR", "FOUNDATION"],
  FOUNDATION_COMPONENT: ["EDGE_BEHAVIOR", "FOUNDATION_ASSEMBLY"],
  FOUNDATION_SYSTEM: ["FOUNDATION"],
  FRAME_FLOOR_ASSEMBLY: ["FLOOR_SYSTEM", "SETTINGS"],
  FRAMING_COMPONENT: ["FLOOR_SYSTEM", "FRAME_FLOOR_ASSEMBLY", "HEADER_ASSEMBLY", "WALL_PLANE_ASSEMBLY"],
  GENERATED_ENTITY: [],
  GLOBAL_PARAMETER: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELEVATION",
    "FACADE",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR",
    "FLOOR_FINISH",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_SYSTEM",
    "GROUP",
    "LEVEL",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "OPTION",
    "OPTION_LOCK",
    "OPTION_RULE",
    "OPTION_SET",
    "OPTION_SET_OVERRIDES",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "ROOM",
    "ROOM_LAYOUT_INSTANCE",
    "RULE_BASED_SELECTOR",
    "SETTINGS",
    "SETTINGS_SET",
    "SHAPE",
    "SHEET",
    "SITE",
    "SITE_SHAPE",
    "SKYLIGHT",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "VIEW_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_RULE",
    "WALL_PLANE_TRIM",
  ],
  GROUP: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_SEQUENCE",
    "DATUM",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "FACADE",
    "FLOOR",
    "FLOOR_FINISH",
    "FOUNDATION_ASSEMBLY",
    "FOUNDATION_COMPONENT",
    "FRAME_FLOOR_ASSEMBLY",
    "FRAMING_COMPONENT",
    "GLOBAL_PARAMETER",
    "HEADER_ASSEMBLY",
    "MASONRY_COMPONENT",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "PALETTE",
    "PROP",
    "PROP_INSTANCE",
    "RAILING",
    "REFERENCE_GEOM",
    "ROOF",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "SETTINGS_SET",
    "SHEATHING_COMPONENT",
    "SHEET",
    "SITE",
    "SLAB_COMPONENT",
    "SLAB_FLOOR_ASSEMBLY",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "SYSTEM_PARAMETER",
    "WALL_PLANE_ASSEMBLY",
  ],
  HEADER_ASSEMBLY: ["SETTINGS"],
  INDETERMINATE_ENTITY_TYPE: [],
  INSTANCE_OPTION_SET: [],
  LABEL: [
    "ANNOTATION",
    "CEILING",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "ELECTRICAL_DEVICE",
    "ELEVATION_VIEW",
    "FLOOR",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PLAN_VIEW",
    "PROP",
    "PROP_INSTANCE",
    "RAILING",
    "REPORTABLE_UNIT_DESIGNATION",
    "ROOF",
    "ROOM",
    "RULE_BASED_SELECTOR",
    "SECTION_VIEW",
    "SETTINGS",
    "SHEET",
    "STAIR_SYSTEM",
    "VIEW_3D",
    "VIEW_TEMPLATE_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_ASSEMBLY",
  ],
  LEVEL: [
    "ANNOTATION",
    "BLOCK",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "COMPOSITE_LEVEL",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DATUM",
    "EDGE_BEHAVIOR",
    "FOUNDATION",
    "GLOBAL_PARAMETER",
    "LEVEL",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PLAN_VIEW",
    "RAILING",
    "ROOF",
    "SELECTOR",
    "SETTINGS",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "UNDERLAY",
    "VIEW_3D",
    "VIEWPORT",
  ],
  LOCAL_PARAMETER: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELEVATION",
    "FACADE",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR",
    "FLOOR_FINISH",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_SYSTEM",
    "GROUP",
    "LEVEL",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "OPTION",
    "OPTION_LOCK",
    "OPTION_RULE",
    "OPTION_SET",
    "OPTION_SET_OVERRIDES",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "ROOM",
    "ROOM_LAYOUT_INSTANCE",
    "RULE_BASED_SELECTOR",
    "SETTINGS",
    "SETTINGS_SET",
    "SHAPE",
    "SHEET",
    "SITE",
    "SITE_SHAPE",
    "SKYLIGHT",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "VIEW_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_RULE",
    "WALL_PLANE_TRIM",
  ],
  MASONRY_COMPONENT: ["WALL_PLANE_ASSEMBLY"],
  MEASUREMENT: [],
  MODIFIER: ["EDGE_MODIFIER"],
  OPENING: ["ENTITY_SETTINGS", "ROOM_LAYOUT_INSTANCE"],
  OPTION: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELEVATION",
    "FACADE",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR",
    "FLOOR_FINISH",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_SYSTEM",
    "GLOBAL_PARAMETER",
    "GROUP",
    "LEVEL",
    "LOCAL_PARAMETER",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "OPTION",
    "OPTION_EFFECT",
    "OPTION_LOCK",
    "OPTION_RULE",
    "OPTION_SET",
    "OPTION_SET_OVERRIDES",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PRESET",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "ROOM",
    "ROOM_LAYOUT_INSTANCE",
    "RULE_BASED_SELECTOR",
    "SETTINGS",
    "SETTINGS_SET",
    "SHAPE",
    "SHEET",
    "SITE",
    "SITE_SHAPE",
    "SKYLIGHT",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "VIEW_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_RULE",
    "WALL_PLANE_TRIM",
  ],
  OPTION_EFFECT: [],
  OPTION_LOCK: [],
  OPTION_RULE: ["OPTION_EFFECT"],
  OPTION_SET: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELEVATION",
    "FACADE",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR",
    "FLOOR_FINISH",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_SYSTEM",
    "GLOBAL_PARAMETER",
    "GROUP",
    "INSTANCE_OPTION_SET",
    "LEVEL",
    "LOCAL_PARAMETER",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "OPTION",
    "OPTION_EFFECT",
    "OPTION_LOCK",
    "OPTION_RULE",
    "OPTION_SET",
    "OPTION_SET_OVERRIDES",
    "OPTION_SET_REF",
    "PRESET",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "ROOM",
    "ROOM_LAYOUT_INSTANCE",
    "RULE_BASED_SELECTOR",
    "SETTINGS",
    "SETTINGS_SET",
    "SHAPE",
    "SHEET",
    "SITE",
    "SITE_SHAPE",
    "SKYLIGHT",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "VIEW_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_RULE",
    "WALL_PLANE_TRIM",
  ],
  OPTION_SET_OVERRIDES: [],
  OPTION_SET_REF: [],
  OPTION_TEMPLATE: ["OPTION_SET_OVERRIDES"],
  PALETTE: [],
  PLAN_SET_TEMPLATE: ["CONTENT_TEMPLATE_INSTANCE", "LOCAL_PARAMETER", "PLAN_SET_TEMPLATE_CONFIG"],
  PLAN_SET_TEMPLATE_CONFIG: [],
  PLAN_VIEW: ["VIEW_SELECTOR"],
  PRESET: [
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "VIEWPORT",
  ],
  PROFILE: [],
  PROP: ["ELECTRICAL_DEVICE", "ELECTRICAL_LAYOUT", "ELECTRICAL_RULE", "PROP_INSTANCE", "ROOF", "SETTINGS"],
  PROP_INSTANCE: ["ROOM_LAYOUT_INSTANCE"],
  RAILING: ["EDGE_MODIFIER", "RAILING_POST"],
  RAILING_POST: [],
  REFERENCE_GEOM: ["ELECTRICAL_DEVICE", "ELECTRICAL_LAYOUT", "ELECTRICAL_RULE", "SETTINGS"],
  REPORTABLE_UNIT_DESIGNATION: [],
  ROOF: ["DORMER", "EDGE_MODIFIER", "ENTITY_SETTINGS", "ROOF_OPENING", "SKYLIGHT", "WALL_PLANE_RULE"],
  ROOF_OPENING: ["ENTITY_SETTINGS"],
  ROOF_SIDE: [],
  ROOF_SYSTEM: ["ROOF"],
  ROOF_VOLUME: [],
  ROOM: [
    "ANNOTATION",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "CONTENT_TEMPLATE_INSTANCE",
    "EDGE_BEHAVIOR",
    "EDGE_MODIFIER",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELECTRICAL_RULE",
    "ENTITY_SETTINGS",
    "FLOOR",
    "FLOOR_FINISH",
    "MEASUREMENT",
    "OPENING",
    "PROP_INSTANCE",
    "ROOM_LAYOUT",
    "ROOM_LAYOUT_INSTANCE",
    "SELECTOR",
    "SETTINGS",
    "SHAPE",
    "STAIR_BLOCK",
  ],
  ROOM_LAYOUT: [
    "ANNOTATION",
    "CASEWORK",
    "CONTENT_TEMPLATE_INSTANCE",
    "OPENING",
    "PROP_INSTANCE",
    "ROOM_LAYOUT_INSTANCE",
  ],
  ROOM_LAYOUT_INSTANCE: [],
  RULE_BASED_SELECTOR: ["RULE_BASED_SELECTOR_INSTANCE"],
  RULE_BASED_SELECTOR_INSTANCE: [],
  SECTION_VIEW: [
    "ANNOTATION",
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "VIEW_SELECTOR",
  ],
  SELECTOR: [],
  SETTINGS: [
    "CASEWORK",
    "COLUMN",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELECTRICAL_RULE",
    "ENTITY_SETTINGS",
    "FACADE_SWEEP_STRATUM",
    "OPENING",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "SETTINGS",
    "WALL_PLANE_TRIM",
  ],
  SETTINGS_SET: ["ELECTRICAL_RULE", "ENTITY_SETTINGS", "PROP", "SETTINGS"],
  SHAPE: [],
  SHEATHING_COMPONENT: ["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY", "WALL_PLANE_ASSEMBLY"],
  SHEET: ["DRAWING_REF"],
  SITE: ["SITE_SHAPE"],
  SITE_SHAPE: [],
  SKYLIGHT: [],
  SLAB_COMPONENT: ["SLAB_FLOOR_ASSEMBLY"],
  SLAB_FLOOR_ASSEMBLY: ["FLOOR_SYSTEM", "SETTINGS"],
  STAIR_BLOCK: ["COLUMN", "EDGE_BEHAVIOR", "SETTINGS", "STAIR_BLOCK"],
  STAIR_SYSTEM: ["STAIR_BLOCK"],
  SYSTEM_PARAMETER: [
    "ANNOTATION",
    "BLOCK",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "COMPONENT_INSTANCE",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "DORMER",
    "DRAWING_REF",
    "EDGE_BEHAVIOR",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "ELEVATION",
    "FACADE",
    "FACADE_SPAN_STRATUM",
    "FACADE_SWEEP_STRATUM",
    "FLOOR",
    "FLOOR_FINISH",
    "FLOOR_SYSTEM",
    "FOUNDATION",
    "FOUNDATION_SYSTEM",
    "GROUP",
    "LEVEL",
    "MEASUREMENT",
    "MODIFIER",
    "OPENING",
    "OPTION",
    "OPTION_LOCK",
    "OPTION_RULE",
    "OPTION_SET",
    "OPTION_SET_OVERRIDES",
    "PLAN_SET_TEMPLATE_CONFIG",
    "PROP_INSTANCE",
    "RAILING",
    "ROOF",
    "ROOF_OPENING",
    "ROOF_SYSTEM",
    "ROOF_VOLUME",
    "ROOM",
    "ROOM_LAYOUT_INSTANCE",
    "RULE_BASED_SELECTOR",
    "SETTINGS",
    "SETTINGS_SET",
    "SHAPE",
    "SHEET",
    "SITE",
    "SITE_SHAPE",
    "SKYLIGHT",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "VIEW_OVERRIDE",
    "VIEWPORT",
    "WALL_PLANE_RULE",
    "WALL_PLANE_TRIM",
  ],
  UNDERLAY: [],
  VERTEX: [],
  VIEW_3D: ["CONTENT_TEMPLATE_INSTANCE", "PLAN_SET_TEMPLATE_CONFIG", "VIEW_SELECTOR"],
  VIEW_OVERRIDE: ["SELECTOR", "VIEW_SELECTOR"],
  VIEW_SELECTOR: [],
  VIEW_TEMPLATE: [
    "CONTENT_TEMPLATE_INSTANCE",
    "GLOBAL_PARAMETER",
    "LOCAL_PARAMETER",
    "PLAN_SET_TEMPLATE_CONFIG",
    "VIEWPORT",
  ],
  VIEW_TEMPLATE_OVERRIDE: ["EFFECT", "RULE_BASED_SELECTOR_INSTANCE", "VIEW_TEMPLATE", "VIEWPORT"],
  VIEWPORT: [],
  WALL_PLANE_ASSEMBLY: ["WALL_PLANE_RULE"],
  WALL_PLANE_FILTER: ["WALL_PLANE_RULE"],
  WALL_PLANE_RULE: ["WALL_PLANE_TRIM"],
  WALL_PLANE_TRIM: [],
} as const;

/**
 * docEntityTypeToParentTypes maps each DocEntityType to its possible parent entity types.
 * This is extracted from parentId fields with PARENT hierarchy constraints.
 * This replaces the manually-maintained DocEntityTypeToParentHandleType interface.
 *
 * NOTE TO ENGINEER: avoid using this mapping directly in favor of using the getDocEntityParentTypes() function from building-types/doc/docEntityConstraintTools.ts.
 * This util will remove the readonly modifier for standard array operations.
 */
export const docEntityTypeToParentTypes = {
  ANNOTATION: [
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "ELEVATION_VIEW",
    "LEVEL",
    "ROOM",
    "ROOM_LAYOUT",
    "SECTION_VIEW",
  ],
  ASSET: [],
  AUTO_DIMENSION: [],
  BLOCK: ["LEVEL"],
  BUILDER_REF: [],
  CASEWORK: ["ROOM", "ROOM_LAYOUT"],
  CATALOG_ITEM: ["SETTINGS"],
  CEILING: ["ROOM"],
  COLUMN: ["ROOM"],
  COMPONENT: [],
  COMPONENT_INSTANCE: [],
  COMPOSITE_LEVEL: [],
  CONTENT_REPLICATOR: ["CONTENT_TEMPLATE"],
  CONTENT_TEMPLATE: [],
  CONTENT_TEMPLATE_INSTANCE: [
    "CONTENT_TEMPLATE",
    "CONTENT_TEMPLATE_INSTANCE",
    "ELEVATION_VIEW",
    "LEVEL",
    "PLAN_SET_TEMPLATE",
    "ROOM",
    "ROOM_LAYOUT",
    "SECTION_VIEW",
  ],
  DATA_SEQUENCE: [],
  DATA_TABLE: ["CONTENT_TEMPLATE", "CONTENT_TEMPLATE_INSTANCE"],
  DATUM: [],
  DOC_REF: [],
  DORMER: ["ROOF"],
  DRAWING_REF: ["SHEET"],
  EDGE: ["SHAPE"],
  EDGE_BEHAVIOR: ["ROOM", "STAIR_BLOCK"],
  EDGE_MODIFIER: ["RAILING", "ROOF", "ROOM"],
  EDIT_MODE: [],
  EFFECT: ["VIEW_TEMPLATE_OVERRIDE"],
  ELECTRICAL_DEVICE: ["ROOM"],
  ELECTRICAL_LAYOUT: ["ROOM"],
  ELECTRICAL_RULE: ["SETTINGS"],
  ELEVATION: [],
  ELEVATION_VIEW: [],
  ENTITY_SETTINGS: [],
  FACADE: [],
  FACADE_SPAN_STRATUM: ["FACADE"],
  FACADE_SWEEP_STRATUM: ["FACADE"],
  FLOOR: ["FLOOR_SYSTEM", "ROOM"],
  FLOOR_BAY: [],
  FLOOR_FINISH: ["ROOM"],
  FLOOR_PERIMETER_OPENING: ["FLOOR"],
  FLOOR_SPLIT_LINE: [],
  FLOOR_SYSTEM: [],
  FOUNDATION: ["FOUNDATION_SYSTEM"],
  FOUNDATION_ASSEMBLY: [],
  FOUNDATION_COMPONENT: [],
  FOUNDATION_SYSTEM: [],
  FRAME_FLOOR_ASSEMBLY: [],
  FRAMING_COMPONENT: [],
  GENERATED_ENTITY: [],
  GLOBAL_PARAMETER: [],
  GROUP: [],
  HEADER_ASSEMBLY: [],
  INDETERMINATE_ENTITY_TYPE: [],
  INSTANCE_OPTION_SET: ["OPTION_SET"],
  LABEL: [],
  LEVEL: [],
  LOCAL_PARAMETER: ["CONTENT_TEMPLATE", "PLAN_SET_TEMPLATE"],
  MASONRY_COMPONENT: [],
  MEASUREMENT: ["ROOM"],
  MODIFIER: [],
  OPENING: ["ROOM", "ROOM_LAYOUT"],
  OPTION: ["OPTION_SET"],
  OPTION_EFFECT: ["OPTION_RULE"],
  OPTION_LOCK: [],
  OPTION_RULE: [],
  OPTION_SET: [],
  OPTION_SET_OVERRIDES: ["OPTION_TEMPLATE"],
  OPTION_SET_REF: [],
  OPTION_TEMPLATE: [],
  PALETTE: [],
  PLAN_SET_TEMPLATE: [],
  PLAN_SET_TEMPLATE_CONFIG: ["PLAN_SET_TEMPLATE"],
  PLAN_VIEW: [],
  PRESET: [],
  PROFILE: [],
  PROP: [],
  PROP_INSTANCE: ["ROOM", "ROOM_LAYOUT"],
  RAILING: [],
  RAILING_POST: ["RAILING"],
  REFERENCE_GEOM: [],
  REPORTABLE_UNIT_DESIGNATION: [],
  ROOF: ["ROOF_SYSTEM"],
  ROOF_OPENING: ["ROOF"],
  ROOF_SIDE: ["ROOF"],
  ROOF_SYSTEM: [],
  ROOF_VOLUME: [],
  ROOM: ["BLOCK"],
  ROOM_LAYOUT: ["ROOM"],
  ROOM_LAYOUT_INSTANCE: ["ROOM"],
  RULE_BASED_SELECTOR: [],
  RULE_BASED_SELECTOR_INSTANCE: ["VIEW_TEMPLATE_OVERRIDE"],
  SECTION_VIEW: [],
  SELECTOR: ["COMPOSITE_LEVEL", "LEVEL", "ROOM"],
  SETTINGS: ["LEVEL", "ROOM", "SETTINGS_SET"],
  SETTINGS_SET: [],
  SHAPE: [
    "ROOM",
    "ROOF",
    "REFERENCE_GEOM",
    "ANNOTATION",
    "STAIR_BLOCK",
    "ROOM_LAYOUT_INSTANCE",
    "RAILING",
    "CEILING",
    "FLOOR_FINISH",
    "MEASUREMENT",
    "SITE_SHAPE",
    "VIEWPORT",
    "EDIT_MODE",
    "FLOOR",
    "FLOOR_BAY",
    "FLOOR_SPLIT_LINE",
    "FOUNDATION",
  ],
  SHEATHING_COMPONENT: [],
  SHEET: [],
  SITE: [],
  SITE_SHAPE: ["SITE"],
  SKYLIGHT: ["ROOF"],
  SLAB_COMPONENT: [],
  SLAB_FLOOR_ASSEMBLY: [],
  STAIR_BLOCK: ["STAIR_SYSTEM"],
  STAIR_SYSTEM: [],
  SYSTEM_PARAMETER: [],
  UNDERLAY: [],
  VERTEX: ["SHAPE"],
  VIEW_3D: [],
  VIEW_OVERRIDE: [],
  VIEW_SELECTOR: [],
  VIEW_TEMPLATE: [],
  VIEW_TEMPLATE_OVERRIDE: [],
  VIEWPORT: ["CONTENT_TEMPLATE", "CONTENT_TEMPLATE_INSTANCE"],
  WALL_PLANE_ASSEMBLY: [],
  WALL_PLANE_FILTER: [],
  WALL_PLANE_RULE: [],
  WALL_PLANE_TRIM: [],
} as const;

/**
 * docEntityTypeToChildTypes maps each DocEntityType to its possible child entity types.
 * This is the inverse of docEntityTypeToParentTypes - for each entity type, it lists
 * all entity types that have it as a possible parent.
 *
 * NOTE TO ENGINEER: avoid using this mapping directly in favor of using the getDocEntityChildTypes() function from building-types/doc/docEntityConstraintTools.ts.
 * This util will remove the readonly modifier for standard array operations.
 */
export const docEntityTypeToChildTypes = {
  ANNOTATION: ["SHAPE"],
  ASSET: [],
  AUTO_DIMENSION: [],
  BLOCK: ["ROOM"],
  BUILDER_REF: [],
  CASEWORK: [],
  CATALOG_ITEM: [],
  CEILING: ["SHAPE"],
  COLUMN: [],
  COMPONENT: [],
  COMPONENT_INSTANCE: [],
  COMPOSITE_LEVEL: ["SELECTOR"],
  CONTENT_REPLICATOR: [],
  CONTENT_TEMPLATE: [
    "ANNOTATION",
    "CONTENT_REPLICATOR",
    "CONTENT_TEMPLATE_INSTANCE",
    "DATA_TABLE",
    "LOCAL_PARAMETER",
    "VIEWPORT",
  ],
  CONTENT_TEMPLATE_INSTANCE: ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE", "DATA_TABLE", "VIEWPORT"],
  DATA_SEQUENCE: [],
  DATA_TABLE: [],
  DATUM: [],
  DOC_REF: [],
  DORMER: [],
  DRAWING_REF: [],
  EDGE: [],
  EDGE_BEHAVIOR: [],
  EDGE_MODIFIER: [],
  EDIT_MODE: ["SHAPE"],
  EFFECT: [],
  ELECTRICAL_DEVICE: [],
  ELECTRICAL_LAYOUT: [],
  ELECTRICAL_RULE: [],
  ELEVATION: [],
  ELEVATION_VIEW: ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE"],
  ENTITY_SETTINGS: [],
  FACADE: ["FACADE_SPAN_STRATUM", "FACADE_SWEEP_STRATUM"],
  FACADE_SPAN_STRATUM: [],
  FACADE_SWEEP_STRATUM: [],
  FLOOR: ["FLOOR_PERIMETER_OPENING", "SHAPE"],
  FLOOR_BAY: ["SHAPE"],
  FLOOR_FINISH: ["SHAPE"],
  FLOOR_PERIMETER_OPENING: [],
  FLOOR_SPLIT_LINE: ["SHAPE"],
  FLOOR_SYSTEM: ["FLOOR"],
  FOUNDATION: ["SHAPE"],
  FOUNDATION_ASSEMBLY: [],
  FOUNDATION_COMPONENT: [],
  FOUNDATION_SYSTEM: ["FOUNDATION"],
  FRAME_FLOOR_ASSEMBLY: [],
  FRAMING_COMPONENT: [],
  GENERATED_ENTITY: [],
  GLOBAL_PARAMETER: [],
  GROUP: [],
  HEADER_ASSEMBLY: [],
  INDETERMINATE_ENTITY_TYPE: [],
  INSTANCE_OPTION_SET: [],
  LABEL: [],
  LEVEL: ["ANNOTATION", "BLOCK", "CONTENT_TEMPLATE_INSTANCE", "SELECTOR", "SETTINGS"],
  LOCAL_PARAMETER: [],
  MASONRY_COMPONENT: [],
  MEASUREMENT: ["SHAPE"],
  MODIFIER: [],
  OPENING: [],
  OPTION: [],
  OPTION_EFFECT: [],
  OPTION_LOCK: [],
  OPTION_RULE: ["OPTION_EFFECT"],
  OPTION_SET: ["INSTANCE_OPTION_SET", "OPTION"],
  OPTION_SET_OVERRIDES: [],
  OPTION_SET_REF: [],
  OPTION_TEMPLATE: ["OPTION_SET_OVERRIDES"],
  PALETTE: [],
  PLAN_SET_TEMPLATE: ["CONTENT_TEMPLATE_INSTANCE", "LOCAL_PARAMETER", "PLAN_SET_TEMPLATE_CONFIG"],
  PLAN_SET_TEMPLATE_CONFIG: [],
  PLAN_VIEW: [],
  PRESET: [],
  PROFILE: [],
  PROP: [],
  PROP_INSTANCE: [],
  RAILING: ["EDGE_MODIFIER", "RAILING_POST", "SHAPE"],
  RAILING_POST: [],
  REFERENCE_GEOM: ["SHAPE"],
  REPORTABLE_UNIT_DESIGNATION: [],
  ROOF: ["DORMER", "EDGE_MODIFIER", "ROOF_OPENING", "ROOF_SIDE", "SHAPE", "SKYLIGHT"],
  ROOF_OPENING: [],
  ROOF_SIDE: [],
  ROOF_SYSTEM: ["ROOF"],
  ROOF_VOLUME: [],
  ROOM: [
    "ANNOTATION",
    "CASEWORK",
    "CEILING",
    "COLUMN",
    "CONTENT_TEMPLATE_INSTANCE",
    "EDGE_BEHAVIOR",
    "EDGE_MODIFIER",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "FLOOR",
    "FLOOR_FINISH",
    "MEASUREMENT",
    "OPENING",
    "PROP_INSTANCE",
    "ROOM_LAYOUT",
    "ROOM_LAYOUT_INSTANCE",
    "SELECTOR",
    "SETTINGS",
    "SHAPE",
  ],
  ROOM_LAYOUT: ["ANNOTATION", "CASEWORK", "CONTENT_TEMPLATE_INSTANCE", "OPENING", "PROP_INSTANCE"],
  ROOM_LAYOUT_INSTANCE: ["SHAPE"],
  RULE_BASED_SELECTOR: [],
  RULE_BASED_SELECTOR_INSTANCE: [],
  SECTION_VIEW: ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE"],
  SELECTOR: [],
  SETTINGS: ["CATALOG_ITEM", "ELECTRICAL_RULE"],
  SETTINGS_SET: ["SETTINGS"],
  SHAPE: ["EDGE", "VERTEX"],
  SHEATHING_COMPONENT: [],
  SHEET: ["DRAWING_REF"],
  SITE: ["SITE_SHAPE"],
  SITE_SHAPE: ["SHAPE"],
  SKYLIGHT: [],
  SLAB_COMPONENT: [],
  SLAB_FLOOR_ASSEMBLY: [],
  STAIR_BLOCK: ["EDGE_BEHAVIOR", "SHAPE"],
  STAIR_SYSTEM: ["STAIR_BLOCK"],
  SYSTEM_PARAMETER: [],
  UNDERLAY: [],
  VERTEX: [],
  VIEW_3D: [],
  VIEW_OVERRIDE: [],
  VIEW_SELECTOR: [],
  VIEW_TEMPLATE: [],
  VIEW_TEMPLATE_OVERRIDE: ["EFFECT", "RULE_BASED_SELECTOR_INSTANCE"],
  VIEWPORT: ["SHAPE"],
  WALL_PLANE_ASSEMBLY: [],
  WALL_PLANE_FILTER: [],
  WALL_PLANE_RULE: [],
  WALL_PLANE_TRIM: [],
} as const;

/**
 * catalogItemTypeToReverseReferenceDocEntityTypes maps a CatalogItemType to the list of DocEntityTypes
 * that can reference it via FK fields. This is used to find reverse references for catalog items
 * like DOOR_DESCRIPTOR and WINDOW_DESCRIPTOR.
 *
 * For example, DOOR_DESCRIPTOR can be referenced by OPENING via the doorType FK field.
 */
export const catalogItemTypeToReverseReferenceDocEntityTypes: {
  [key in CatalogItemType]: DocEntityType[];
} = {
  CASEWORK_DESCRIPTOR: ["CASEWORK"],
  COLUMN_DESCRIPTOR: ["COLUMN", "EDGE_BEHAVIOR"],
  DOOR_DESCRIPTOR: ["ELECTRICAL_LAYOUT", "ELECTRICAL_RULE", "OPENING", "SETTINGS"],
  DRAWING: ["DRAWING_REF", "EDGE_BEHAVIOR"],
  LOAD_DESCRIPTOR: ["ELECTRICAL_DEVICE", "ELECTRICAL_LAYOUT", "ELECTRICAL_RULE", "SETTINGS"],
  PROFILE_EXTRUSION_DESCRIPTOR: ["FACADE_SWEEP_STRATUM", "ROOF", "SETTINGS", "WALL_PLANE_TRIM"],
  PROP: ["ELECTRICAL_DEVICE", "ELECTRICAL_LAYOUT", "ELECTRICAL_RULE", "PROP_INSTANCE", "ROOF", "SETTINGS"],
  RAILING_SETTING: ["RAILING"],
  STAIR_SETTING: [],
  STRUCTURAL_MATERIAL: [],
  WALL_TYPE: ["SETTINGS"],
  WINDOW_DESCRIPTOR: ["DORMER", "OPENING", "ROOF_OPENING"],
};

/**
 * docEntityTypeToCatalogItemTypeReferences maps a DocEntityType to the list of CatalogItemTypes
 * that it can reference via FK fields.
 *
 * For example, OPENING can reference DOOR_DESCRIPTOR or WINDOW_DESCRIPTOR.
 */
export const docEntityTypeToCatalogItemTypeReferences: {
  [key in DocEntityType]: CatalogItemType[];
} = {
  ANNOTATION: [],
  ASSET: [],
  AUTO_DIMENSION: [],
  BLOCK: [],
  BUILDER_REF: [],
  CASEWORK: ["CASEWORK_DESCRIPTOR"],
  CATALOG_ITEM: [],
  CEILING: [],
  COLUMN: ["COLUMN_DESCRIPTOR"],
  COMPONENT: [],
  COMPONENT_INSTANCE: [],
  COMPOSITE_LEVEL: [],
  CONTENT_REPLICATOR: [],
  CONTENT_TEMPLATE: [],
  CONTENT_TEMPLATE_INSTANCE: [],
  DATA_SEQUENCE: [],
  DATA_TABLE: [],
  DATUM: [],
  DOC_REF: [],
  DORMER: ["WINDOW_DESCRIPTOR"],
  DRAWING_REF: ["DRAWING"],
  EDGE: [],
  EDGE_BEHAVIOR: ["COLUMN_DESCRIPTOR", "DRAWING"],
  EDGE_MODIFIER: [],
  EDIT_MODE: [],
  EFFECT: [],
  ELECTRICAL_DEVICE: ["LOAD_DESCRIPTOR", "PROP"],
  ELECTRICAL_LAYOUT: ["DOOR_DESCRIPTOR", "LOAD_DESCRIPTOR", "PROP"],
  ELECTRICAL_RULE: ["DOOR_DESCRIPTOR", "LOAD_DESCRIPTOR", "PROP"],
  ELEVATION: [],
  ELEVATION_VIEW: [],
  ENTITY_SETTINGS: [],
  FACADE: [],
  FACADE_SPAN_STRATUM: [],
  FACADE_SWEEP_STRATUM: ["PROFILE_EXTRUSION_DESCRIPTOR"],
  FLOOR: [],
  FLOOR_BAY: [],
  FLOOR_FINISH: [],
  FLOOR_PERIMETER_OPENING: [],
  FLOOR_SPLIT_LINE: [],
  FLOOR_SYSTEM: [],
  FOUNDATION: [],
  FOUNDATION_ASSEMBLY: [],
  FOUNDATION_COMPONENT: [],
  FOUNDATION_SYSTEM: [],
  FRAME_FLOOR_ASSEMBLY: [],
  FRAMING_COMPONENT: [],
  GENERATED_ENTITY: [],
  GLOBAL_PARAMETER: [],
  GROUP: [],
  HEADER_ASSEMBLY: [],
  INDETERMINATE_ENTITY_TYPE: [],
  INSTANCE_OPTION_SET: [],
  LABEL: [],
  LEVEL: [],
  LOCAL_PARAMETER: [],
  MASONRY_COMPONENT: [],
  MEASUREMENT: [],
  MODIFIER: [],
  OPENING: ["DOOR_DESCRIPTOR", "WINDOW_DESCRIPTOR"],
  OPTION: [],
  OPTION_EFFECT: [],
  OPTION_LOCK: [],
  OPTION_RULE: [],
  OPTION_SET: [],
  OPTION_SET_OVERRIDES: [],
  OPTION_SET_REF: [],
  OPTION_TEMPLATE: [],
  PALETTE: [],
  PLAN_SET_TEMPLATE: [],
  PLAN_SET_TEMPLATE_CONFIG: [],
  PLAN_VIEW: [],
  PRESET: [],
  PROFILE: [],
  PROP: [],
  PROP_INSTANCE: ["PROP"],
  RAILING: ["RAILING_SETTING"],
  RAILING_POST: [],
  REFERENCE_GEOM: [],
  REPORTABLE_UNIT_DESIGNATION: [],
  ROOF: ["PROFILE_EXTRUSION_DESCRIPTOR", "PROP"],
  ROOF_OPENING: ["WINDOW_DESCRIPTOR"],
  ROOF_SIDE: [],
  ROOF_SYSTEM: [],
  ROOF_VOLUME: [],
  ROOM: [],
  ROOM_LAYOUT: [],
  ROOM_LAYOUT_INSTANCE: [],
  RULE_BASED_SELECTOR: [],
  RULE_BASED_SELECTOR_INSTANCE: [],
  SECTION_VIEW: [],
  SELECTOR: [],
  SETTINGS: ["DOOR_DESCRIPTOR", "LOAD_DESCRIPTOR", "PROFILE_EXTRUSION_DESCRIPTOR", "PROP", "WALL_TYPE"],
  SETTINGS_SET: [],
  SHAPE: [],
  SHEATHING_COMPONENT: [],
  SHEET: [],
  SITE: [],
  SITE_SHAPE: [],
  SKYLIGHT: [],
  SLAB_COMPONENT: [],
  SLAB_FLOOR_ASSEMBLY: [],
  STAIR_BLOCK: [],
  STAIR_SYSTEM: [],
  SYSTEM_PARAMETER: [],
  UNDERLAY: [],
  VERTEX: [],
  VIEW_3D: [],
  VIEW_OVERRIDE: [],
  VIEW_SELECTOR: [],
  VIEW_TEMPLATE: [],
  VIEW_TEMPLATE_OVERRIDE: [],
  VIEWPORT: [],
  WALL_PLANE_ASSEMBLY: [],
  WALL_PLANE_FILTER: [],
  WALL_PLANE_RULE: [],
  WALL_PLANE_TRIM: ["PROFILE_EXTRUSION_DESCRIPTOR"],
};

/**
 * docEntityTypeToForeignKeyPathTargetTypes maps each DocEntityType to FK targets
 * discovered through ForeignKeyPath-style structures.
 *
 * A ForeignKeyPath-style structure is detected structurally as:
 * - one or more fields typed as arrays of FK IDs
 */
export const docEntityTypeToForeignKeyPathTargetTypes: {
  [key in DocEntityType]?: readonly DocEntityType[];
} = {
  CEILING: ["COMPONENT_INSTANCE"],
  COMPONENT_INSTANCE: ["COMPONENT_INSTANCE"],
  COMPOSITE_LEVEL: ["COMPONENT_INSTANCE"],
  EDGE_BEHAVIOR: ["COMPONENT_INSTANCE"],
  FACADE_SPAN_STRATUM: ["COMPONENT_INSTANCE"],
  FACADE_SWEEP_STRATUM: ["COMPONENT_INSTANCE"],
  LEVEL: ["COMPONENT_INSTANCE"],
  ROOF: ["COMPONENT_INSTANCE"],
  VIEWPORT: ["COMPONENT_INSTANCE"],
} as const;

/**
 * docEntityTypesWithForeignKeyPaths lists entity types whose data structures contain
 * ForeignKeyPathOf-style fields.
 *
 * These entity types can carry implicit path-based FK dependencies that are nested inside
 * complex structures and are not always directly expressible in DocEntityForeignKeyConstraints.
 */
export const docEntityTypesWithForeignKeyPaths: readonly DocEntityType[] = [
  "CEILING",
  "COMPONENT_INSTANCE",
  "COMPOSITE_LEVEL",
  "EDGE_BEHAVIOR",
  "FACADE_SPAN_STRATUM",
  "FACADE_SWEEP_STRATUM",
  "LEVEL",
  "ROOF",
  "VIEWPORT",
] as const;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-fk-relations directly.
